module.exports = __webpack_public_path__ + "img/jyhd-bj@3x.dc01e962.png";